import { render, staticRenderFns } from "./StarterList.vue?vue&type=template&id=715379ac&scoped=true"
import script from "./StarterList.vue?vue&type=script&lang=js"
export * from "./StarterList.vue?vue&type=script&lang=js"
import style0 from "./StarterList.vue?vue&type=style&index=0&id=715379ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715379ac",
  null
  
)

export default component.exports